var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.475 1.36252L5.275 5.57502C5.225 5.62502 5.17083 5.66052 5.1125 5.68152C5.05417 5.70252 4.99167 5.71285 4.925 5.71252C4.85833 5.71252 4.79583 5.70218 4.7375 5.68152C4.67917 5.66085 4.625 5.62535 4.575 5.57502L0.3625 1.36252C0.245833 1.24585 0.1875 1.10002 0.1875 0.925017C0.1875 0.750017 0.25 0.600017 0.375 0.475017C0.5 0.350017 0.645833 0.287517 0.8125 0.287517C0.979166 0.287517 1.125 0.350017 1.25 0.475017L4.925 4.15002L8.6 0.475017C8.71667 0.35835 8.8605 0.300017 9.0315 0.300016C9.2025 0.300016 9.35033 0.362516 9.475 0.487516C9.6 0.612516 9.6625 0.75835 9.6625 0.925016C9.6625 1.09168 9.6 1.23752 9.475 1.36252Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.e9975e95bbebcae176c71f575fdbb315.svg";
export { ForwardRef as ReactComponent };